$(->
  $('.render-pdf').each ->
    renderPdf($(this))
)
pdfjsLib = require('../../pdfjs')

renderPdf = (el) ->
  the_div = $(el)
  pdfjsLib.getDocument(the_div.data('file')).then (pdf)->
    the_div.html('')
    the_div.html('')
    pageNum = 0
    while pageNum < pdf.numPages
      pageNum++
      pdf.getPage(pageNum).then (page)->
        scale = (the_div.width() * window.devicePixelRatio) / page.getViewport(1.0).width
        viewport = page.getViewport(scale)
        content = "<div id=\"pdf-page-wrapper-#{page.pageIndex}\" class=\"page\">
          <canvas id=\"pdf-page-#{page.pageIndex}\" class=\"pdf-page\">
          </canvas></div>"
        the_div.append(content)
        canvas = the_div.find("#pdf-page-#{page.pageIndex}").get(0)
        wrapper = the_div.find("#pdf-page-wrapper-#{page.pageIndex}").get(0)
        canvas.height = viewport.height
        canvas.width = viewport.width
        canvas.style.width = '100%'
        canvas.style.height = 'auto'
        wrapper.style.width = '100%'
        wrapper.style.height = 'auto'
        context = canvas.getContext('2d')
        renderContext = {
          canvasContext: context,
          viewport: viewport
        }
        page.render(renderContext)
  , (err)->
    console.log(err)

module.exports =
  renderPdf: renderPdf
